<template>
  <div class="container">
    <!-- 左侧文字部分 -->
    <div class="text-content">
      <h1>{{ $t('core.title1') }}</h1>
      <h1>{{ $t('core.title2') }}</h1>
      <!-- <div class="stats">
        <div class="stat-item">
          <span class="number">1亿</span>
          <span class="label">
            用户
            <span class="underline"></span>
          </span>
        </div>
        <div class="stat-item">
          <span class="number">180</span>
          <span class="label">
            国家和地区
            <span class="underline"></span>
          </span>
        </div>
        <div class="stat-item">
          <span class="number">15000</span>
          <span class="label">
            员工
            <span class="underline"></span>
          </span>
        </div>
        <div class="stat-item">
          <span class="number">28</span>
          <span class="label">
            年
            <span class="underline"></span>
          </span>
        </div>
        <div class="stat-item">
          <span class="number">2000</span>
          <span class="label">
            合作伙伴
            <span class="underline"></span>
          </span>
        </div>
      </div> -->
      <button class="learn-more" @click="toDemo">{{ $t('core.tryFree') }}</button>
    </div>

    <!-- 右侧图片部分 -->
    <div class="image-content">
      <img src="@/assets/img/carbon/made-au-bg2.png" alt="Background Image">
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoreCompetence',
  methods: {
    toDemo() {
      this.$router.push('/trial')
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100vw; /* 限制最大宽度为视口宽度 */
  max-width: 100%; /* 避免超出父级 */
  height: 70vh;
  background-color: #339216;
  color: white;
  padding: 0 calc(5% + 0.5rem); /* 根据屏幕动态调整留白 */
  box-sizing: border-box; /* 确保盒模型不被缩放影响 */
  overflow-x: hidden; /* 隐藏横向溢出内容 */
}

.text-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-left: calc(8% + 1rem); /* 文字部分动态偏移 */
  text-align: left;
}

.text-content h1 {
  font-size: 2.0rem; /* rem 单位字体 */
  margin-bottom: 1rem;
}

.stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 两列布局 */
  gap: 1.2rem 2.5rem; /* 动态间距 */
  margin-bottom: 2rem;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.number {
  font-size: 1.8rem;
  font-weight: bold;
  color: #fff;
}

.label {
  position: relative;
  font-size: 1rem;
  color: #fff;
}

.label .underline {
  position: absolute;
  content: '';
  display: block;
  width: 100%; /* 横线宽度与文字等宽 */
  height: 1px;
  background-color: white;
  bottom: -0.2rem;
  left: 0;
}

.learn-more {
  background: white;
  color: #005eb8;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 5px;
  cursor: pointer;
}

.image-content {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  transform: scale(1.2); /* 修正缩放影响的图片布局 */
  margin-right: calc(-5%); /* 缩放后重新调整偏移 */
  margin-bottom: 0rem;
}

.image-content img {
  width: 75%;
  height: 538px;
  object-fit: cover;
}

/* 高 DPI 屏幕缩放适配 */
@media (min-width: 1920px) and (max-width: 2560px) {
  .container {
    height: 65vh; /* 动态高度修正 */
    padding: 0 calc(4% + 1rem);
  }

  .text-content {
    padding-left: calc(6% + 1rem);
  }

  .text-content h1 {
    font-size: 2.2rem; /* 动态缩小字体 */
  }

  .number {
    font-size: 1.6rem;
  }

  .label {
    font-size: 0.9rem;
  }

  .image-content {
    transform: scale(1.1); /* 减小缩放 */
    margin-right:-3%; /* 减少偏移 */
  }
}

/* 小屏幕适配 */
@media (max-width: 768px) {
  .container {
    flex-direction: column;
    height: auto;
    padding: 2rem 3vw;
  }

  .text-content {
    align-items: center;
    text-align: center;
    padding-left: 0;
  }

  .text-content h1 {
    font-size: 2rem;
    margin-bottom: 0.8rem;
  }

  .stats {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .stat-item {
    justify-content: center;
  }

  .number {
    font-size: 1.5rem;
  }

  .label {
    font-size: 0.9rem;
  }

  .image-content {
    justify-content: center;
    margin-top: 2rem;
    transform: scale(1); /* 还原缩放 */
    margin-right: 0;
  }

  .image-content img {
    width: 100%;
  }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
  .text-content h1 {
    font-size: 1.8rem;
  }

  .stats {
    gap: 0.8rem;
  }

  .number {
    font-size: 1.2rem;
  }

  .label {
    font-size: 0.8rem;
  }

  .learn-more {
    padding: 0.4rem 1rem;
    font-size: 0.8rem;
  }
}
</style>
